module.exports = __webpack_public_path__ + "static/media/valor2.bf36ca43.png";